export default "__VITE_ASSET__viOxYywy__"